export const ItemTypes = {
  Box: 'box',
	DraggableBox: 'draggablebox',
}
